export const HOME_TAB = 'Home';
export const CALENDAR_TAB = 'Calendar';
export const MESSAGING_TAB = 'Messages';
export const SETUP_TAB = 'Setup';
